import script from "./ImgEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImgEditModal.vue?vue&type=script&setup=true&lang=js"

import "./ImgEditModal.vue?vue&type=style&index=0&id=6e012b04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e012b04"]])

export default __exports__